import { api } from "./client";

export type Settings = {
  id: number;
  homeAddress: string | null;
};

export type SettingsUpdate = {
  homeAddress: string;
};

export const settingsApi = {
  get: () => api.get<Settings>("/api/settings"),

  update: (data: SettingsUpdate) => api.put<Settings>("/api/settings", data),
};
